 <template>
    <div class="modal_shadow">
        <div class="modal_wrap">
            <slot name="content"></slot>
            <div class="close_btn" @click="closeModal">{{$t("common.close")}}</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
         
        };
    },
    mounted() {},
    methods: {
        closeModal() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../style/mixin.scss";
@-webkit-keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.modal_shadow {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 20;
    background: rgba(0, 0, 0, 0.6);
    .modal_wrap {
        // @include center2(22.1875rem /* 355/16 */, 80%);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 22.1875rem /* 355/16 */;
        max-height: 80%;
        background-color: #ffffff;
        border-radius: 0.5rem /* 8/16 */;
        box-sizing: border-box;
        animation: fadeIn 0.4s;
        .close_btn {
            @include sc(0.8rem, #fff);
            @include cl();
            width: 20.625rem /* 330/16 */;
            bottom: 0.625rem /* 10/16 */;
            background-color: #ad011b;
            font-weight: bold;
            text-align: center;
            line-height: 2.1875rem /* 35/16 */;
            border-radius: 0.3125rem /* 5/16 */;
        }
    }
}
</style>
